import { css } from '@emotion/react';
import { token } from '@atlaskit/tokens';
import { colors } from '@atlaskit/theme';

export const modalBlanketStyle = css`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${token('color.blanket', 'rgba(16, 18, 20, 0.6)')};
  display: flex;
  justify-content: center;
`;

export const modalContainer = css`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 752px;
  border-radius: 5px;
  box-shadow: 0px 4px 4px 0px ${token('color.blanket', colors.N200)};
  background-color: ${token('elevation.surface', colors.N0)};

  footer {
    display: flex;
  }
`;

export const modalHeader = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const formRow = css`
  display: flex;
  flex-direction: row;
  gap: 50px;
  margin: 12px 0;
`;

export const divider = css`
  height: 2px;
  margin-top: 24px;
  margin-bottom: 12px;
  border: none;
  background-color: var(--ds-border, ${token('color.border', colors.DN300A)});
`;
